import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  check: {
    color: '#FFF',
  },
  connector: {
    backgroundColor: '#62A644',
    height: '2.5rem',
    width: '3px',
  },
  connectorGreen: {
    backgroundColor: '#D9D9D9',
    height: '2.5rem',
    width: '3px',
  },
  container: {
    backgroundColor: '#FFF',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  dotActive: {
    color: '#231F20',
    backgroundColor: '#FFF',
    border: '2px solid red',
  },
  dotFinished: {
    backgroundColor: '#5AB031',
    color: '#FFF',
  },
  dotPending: {
    backgroundColor: '#CEE1F8',
    color: '#0C1B2B',
    opacity: 0.3,
  },
  stepDescription: {
    color: '#231F20',
    fontSize: '14px',
    fontWeight: 'bold',
    lineHeight: '16px',
    width: '200px',
  },
  stepNumber: {
    fontWeight: 'bold',
    margin: '1px 3px',
    textAlign: 'center',
    width: '1.25rem',
  },
  stepTextInactive: {
    color: '#stepTextInactive',
    opacity: 0.3,
  },
  stepTitle: {
    color: '#5AB031',
    fontSize: '12px',
    fontWeight: 'bold',
    lineHeight: '14px',
    marginBottom: '5px',
    marginTop: '3px',
  },
}));
